export enum TicketEsquemaPerfil {
    NOMINA='Nomina', 
    HIBRIDO='Híbrido',
}

export enum TicketProyectoPerfil {
    ASIGNADO='Asignado',
    PROYECTO='Proyecto',
}

export enum TicketNivelPerfil {
    PRACTICANTE='Practicante',
    JUNIOR='Junior', 
    MID='Medio',
    SENIOR='Senior',
    EXPERTO='Experto'
}

export enum TicketAprobadoPerfil {
    DG='DG', 
    DIRECCIÓN_ADJUNTA='Dirección adjunta',
    NO='NA',
}
